const Configuration = {
  api: 'https://api.insane-mag.com', // process.env.API_URL,
  public: process.env.PUBLIC_URL,
  editor: process.env.EDITOR_URL,
  images: process.env.IMAGES_URL,
}

export default Configuration
